/**
 * Canonical endorsement qualities by app community.
 * Members pick from these after an IRL meetup.
 */
import type { AppId } from "@/lib/apps";

export const SHARED_QUALITIES = [
  "Great conversation",
  "Showed up on time",
  "Made me feel safe",
  "Genuinely kind",
  "Funny",
  "Curious",
  "Thoughtful listener",
  "Followed through",
];

export const APP_QUALITIES: Record<AppId, string[]> = {
  fryqnc: ["Affirming", "Pride-positive", "Community-minded"],
  pulsynq: ["Cultural pride", "Family-oriented", "Faith-respectful"],
  mindlynq: ["Sensory-aware", "Patient communicator", "Honored my needs"],
  ablelynq: ["Access-aware", "Patient", "Respected my pace"],
  deafwav: ["Visual-first communicator", "ASL-friendly", "Clear and patient"],
  fullynq: ["Body-affirming", "Confidence-building", "Genuinely respectful"],
  jadesynq: ["Cultural pride", "Family-oriented", "Intergenerational respect"],
  openlynq: ["Clear communicator", "Consent-first", "Respected boundaries"],
  spiritsynq: ["Reverent", "Open-hearted", "Practice-respectful"],
};

export const qualitiesFor = (app: AppId | null): string[] => {
  if (!app) return SHARED_QUALITIES;
  return [...SHARED_QUALITIES, ...APP_QUALITIES[app]];
};
